<template>
  <v-dialog
    :model-value="modelValue"
    @update:model-value="emit('update:modelValue', $event)"
    max-width="400"
  >
    <v-card>
      <v-card-title class="text-h6">ペアリングコードを入力</v-card-title>
      <v-card-text>
        <v-text-field
          v-model="code"
          label="5文字のコード"
          counter="5"
          maxlength="5"
          variant="outlined"
          @keydown.stop
          @update:model-value="sanitizeCode"
          :error-messages="error"
        />
        <div v-if="error" class="text-error mt-2">{{ error }}</div>
        <div class="text-warning mt-2">
          ゴーグルでアプリの立ち上げ時にYボタンを長押ししてペアリングを開始してください
        </div>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn variant="text" @click="close">キャンセル</v-btn>
        <v-btn color="primary" :loading="loading" @click="submitCode"
          >ペアリング実行</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch } from "vue";
import { useToast } from "vue-toastification";
import { submitPairingCode } from "@/api/pairingAPI"; // ✅ pairingAPI を使用

const props = defineProps({
  modelValue: Boolean,
});

const emit = defineEmits(["update:modelValue"]);

const code = ref("");
const loading = ref(false);
const error = ref("");
const toast = useToast();

// 入力値をサニタイズ（小文字のa-zのみ許可）
const sanitizeCode = (value) => {
  code.value = value.toLowerCase().replace(/[^a-z]/g, "");
};

const close = () => {
  code.value = "";
  error.value = "";
  emit("update:modelValue", false);
};

const submitCode = async () => {
  if (code.value.length !== 5) {
    error.value = "5文字のコードを入力してください";
    return;
  }

  loading.value = true;
  error.value = "";

  try {
    const result = await submitPairingCode(code.value); // ✅ pairingAPI経由で送信

    if (result?.status === "paired") {
      toast.success("✅ ペアリングが完了しました");
      close();
    } else {
      const msg = result?.error || "ペアリングに失敗しました";
      error.value = msg;
      toast.warning(msg);
    }
  } catch (err) {
    console.error(err);
    const msg = err.message || "サーバーとの通信に失敗しました";
    error.value = msg;
    toast.error(msg);
  } finally {
    loading.value = false;
  }
};

watch(
  () => props.modelValue,
  (val) => {
    if (!val) {
      code.value = "";
      error.value = "";
    }
  }
);
</script>
